module.exports = __webpack_public_path__ + "img/sticker-2-1.216cdc38.svg";